/** 15 min in milliseconds */
export const DEFAULT_CACHE_TIME = 15 * 60 * 1000;

/** 5 min in milliseconds */
export const DEFAULT_STALE_TIME = 5 * 60 * 1000;
